import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useStatusVersao = () => {
  const [registro, setRegistro] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchRegistro = async () => {
      try {
        const response = await httpClient.get(
          `/api/notaversaosisaf/statusversaosisaf`,
        );

        const options = response.data.map(
          (opcao: { value: number; label: string }) => ({
            value: opcao.value.toString(),
            label: opcao.label,
          }),
        );
        setRegistro(options);
      } catch (error) {
        console.error('Erro ao buscar Status de Documentos', error);
      }
    };

    fetchRegistro();
  }, []);

  return registro;
};
